import React from "react";
import { AsynchronousProps } from "../../types/common";
import Asynchronous from "./Asynchronous/Asynchronous";

const CitiesSelect = ({
    onChange,
    value,
    field,
    error,
    callbackResult,
}: Omit<AsynchronousProps, "onChange"> & { onChange: (value: string) => void }) => {
    return (
        <Asynchronous
            onChange={item => {
                onChange(item?.value ?? "");
            }}
            value={value}
            label={"Населенный пункт"}
            error={error}
            // searchParams={{ [CONTENT_TYPE]: "city", [WITH_PARENT]: 1 }}
            callbackResult={callbackResult}
            from_bound={{ value: "city" }}
            to_bound={{ value: "settlement" }}
        />
    );
};

export default CitiesSelect;
